import React, { useState } from 'react';
import {
    Box,
    MenuItem,
    TextField
} from '@mui/material';
import { ArrowLeftLinearIcon } from '../../../icons-lib';
import i18n from '../../../i18';

export const FilterText = ({
    onValueChange,
    onBack,
    field
}) => {
    const [searchValue, setSearchValue] = useState('');

    const handleSearchChange = (event) => {
        const value = event.target.value;
        console.log('FilterText handleSearchChange:', value);
        setSearchValue(value);
        
        // Call onValueChange directly for testing
        onValueChange(value);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <MenuItem onClick={onBack}>
                <ArrowLeftLinearIcon sx={{ mr: 2 }} />
                {i18n.t(`columns.${field.label}`)}
            </MenuItem>
            <Box sx={{ p: 2 }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={i18n.t('text.searchPlaceholder')}
                    value={searchValue}
                    onChange={handleSearchChange}
                    size="small"
                    autoComplete="off"
                    autoFocus
                />
            </Box>
        </Box>
    );
}; 